<template>
  <v-app>

    <v-main class="py-0">
      <div class="con_side">

        <v-row justify="center" class="col-12 mb-5 rounded-lg">
          
          <v-col justify="center" class="col-12 pl-md-15 pl-xs-6 pl-8"> 
            <template>
              <v-btn block disabled x-large class="my-5">
                <h3 class="font-weight-bold my-4" :style="`color:${$vuetify.theme.dark ? 'white' : 'black'}`">
                  收費及報價
                </h3>
              </v-btn>
            </template>
            <p class="my-3">一般單次單張委託最低 200 元。<br>依照建模風格、主題複雜度、是否營利、特殊模型跟地形等加價。</p>
            <p class="my-3">包月方案 : 底價2000元，15張，若15張條件皆相同，則加價只會增加一次。</p>          

            <template>
              <v-btn block disabled x-large class="my-5">
                <h3 class="font-weight-bold my-4" :style="`color:${$vuetify.theme.dark ? 'white' : 'black'}`">
                  付款方式
                </h3>
              </v-btn>
            </template>
            <p class="my-3">超商代碼 / 銀行轉帳 / Paypal</p>

            <template>
              <v-btn block disabled x-large class="my-5">
                <h3 class=" font-weight-bold my-4" :style="`color:${$vuetify.theme.dark ? 'white' : 'black'}`">
                  委託授權範圍
                </h3>
              </v-btn>
            </template>

            <p class="my-3">
              請確認人物設定之原創性，本委託不承擔因抄襲、臨摹、描圖等爭議之責任。
            </p>
            <p class="my-3">
              本工坊製作之建模為夜瑀(以下稱製作人)所製作；製作人對建模保持不公開檔案、僅經過委託方同意後，得以公開展示圖。
            </p>
            <p class="my-3">
              本工坊製作之壁紙、展示圖為製作人—夜瑀製作；製作人對作品保有著作權，歡迎公開、並標註作者，但不得聲稱為委託人原創。
            </p>

          </v-col>


        </v-row>



      </div>
    </v-main>
  </v-app>
</template>

<script>


export default {
  data: () => ({

  }),
}
</script>

<style scoped>
  .con_side{
    max-width: 60%;;
    margin-right: auto;
    margin-left: auto;

  }

  @media (max-width: 720px) {
    .con_side{
      max-width: 100%;;
    }
  }

</style>

